import { AxiosHeaders } from "axios";
import { useRef } from "react";

import { Box, Button, Container, Paper, Stack, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { USER_APIS } from "../common/api/apis";
import { getAxiosHeaders, patch } from "../common/shared/AxiosAPI";
import { ResponsiveText } from "../common/shared/ResponsiveText";
import { getLoginId } from "../common/user/UserService";

export const ChangePassword = () => {
  const navigate = useNavigate();

  const newPRef = useRef<HTMLInputElement>();
  const newP2Ref = useRef<HTMLInputElement>();
  const updatePassword = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    try {
      let formData = new FormData(e.currentTarget);
      let password = formData.get("password")?.valueOf().toString();
      let confirmPassword = formData.get("password2")?.valueOf().toString();
      if (password.toLocaleLowerCase() !== confirmPassword.toLocaleLowerCase()) {
        alert("Password and Confirm Password do not match. Please Check.");
        return;
      }
      let cUser = { name: getLoginId(), password: password };

      let cHeaders: AxiosHeaders = getAxiosHeaders();
      cHeaders.set("currentUser", cUser.name);

      patch(USER_APIS.UPDATE_PASSWORD, cHeaders, cUser)
        .then((response) => {
          if (response.status === 200) {
            navigate("/logout", {
              state: {
                logoutMessage: "Password Updated Sucessfully, Please login again !!!",
              },
            });
          }
        })
        .catch((e) => {
          console.log("In .catch");
          console.log(e);
          alert("Opps. Please contact Admin! ");
        });
    } catch (error) {
      console.log("In try-atch");
      alert("Opps. Please contact Admin!");
      console.log(error);
    }
  };

  return (
    <Container maxWidth="xs" sx={{ py: { xs: 3, sm: 6 } }}>
      <Paper variant="outlined" sx={{ p: { xs: 3, sm: 4 }, borderRadius: 2 }}>
        <form onSubmit={updatePassword}>
          <Stack spacing={2.5}>
            <Box>
              <Typography variant="h6" fontWeight={600}>
                Reset Password
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Please enter your new password
              </Typography>
            </Box>
            <TextField
              id="new-password"
              size="small"
              label="New Password"
              variant="outlined"
              name="password"
              required
              fullWidth
              type="password"
              ref={newPRef}
            />
            <TextField
              id="confirm-password"
              size="small"
              label="Confirm Password"
              variant="outlined"
              name="password2"
              required
              fullWidth
              type="password"
              ref={newP2Ref}
            />
            <Stack direction="row" spacing={1.5} justifyContent="flex-end">
              <Button variant="outlined" size="small" onClick={() => navigate("/app/dashboard")}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" color="primary" size="small">
                Update
              </Button>
            </Stack>
          </Stack>
        </form>
      </Paper>
    </Container>
  );

};
